import React, {useContext, useState} from "react";
import {ItemStyled} from "../../../../styles/ContentViews";
import {Grid, Col} from "../../../../styles/Grid";
import DynamicInput, {Label, Input} from "../../../../components/forms/DynamicInput";
import styled from "styled-components";
import EditableImg from "../../../../components/forms/EditableImg";
import {AppButton} from "../../../../styles/Butttons";
import {UpdateSlideHome, DeleteSlideHome} from "../../../../services/GeneralServices";
import {HomeContext} from "../../../../context/HomeProvider";
import AppLoader from "../../../../components/loaders/Loader";

export function EncabezadoItem({data, editable}) {
   const {updateSlide} = useContext(HomeContext);
   const [isSaving, setSaving] = useState(false);

   const saveSlide = (e) => {
      // update
      e.preventDefault();
      let formD = e.target.elements;
      let newArr = {
         idSlideHome: Number(formD.idSlide.value),
         title: formD.title.value,
         subtitle: formD.subtitle.value,
         pathImageWebDesktop: formD[`imgDesk${data.idSlideHome}`].files[0] || data.pathImageWebDesktop,
         pathImageWebMobile: formD[`imgMobile${data.idSlideHome}`].files[0] || data.pathImageWebMobile,
         url: formD.link.value,
      };
      // console.log(newArr);
      if (JSON.stringify(newArr) === JSON.stringify(data)) {
         // si es igual solo cerrarr
      } else {
         setSaving(true);
         let newData = new FormData();
         // newData.append("idSlideHome", newArr.idSlideHome);
         newData.append("token", localStorage.getItem("domecq_token"));
         newData.append("title", newArr.title);
         newData.append("idSlideHome", data.idSlideHome);
         newData.append("subtitle", newArr.subtitle);
         newData.append("url", newArr.url);
         if (formD[`imgDesk${data.idSlideHome}`].files[0]) {
            newData.append("pathImageWebDesktop", formD[`imgDesk${data.idSlideHome}`].files[0]);
         }
         if (formD[`imgMobile${data.idSlideHome}`].files[0]) {
            newData.append("pathImageWebMobile", formD[`imgMobile${data.idSlideHome}`].files[0]);
         }

         // UpdateSlideHome(newData)
         UpdateSlideHome(newData)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
               console.log(resp);
               updateSlide(newArr);
            })
            .then(() => {
               setSaving(false);
            })
            .catch((e) => {
               console.log(e);
            });
      }
      // console.log(newArr, data);
   };

   const deleteItem = () => {
      console.log(data);
      // slidesHome/delete
      DeleteSlideHome(data.idSlideHome)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            console.log(resp);
         })
         .catch((e) => {
            console.log(e);
         });
   };
   return (
      <>
         <ItemStyled>
            {/* 
            <Col large={2} offsetL={10}>
               <AppButton onClick={deleteItem}>Eliminar</AppButton>
            </Col> */}

            <Grid as={editable ? "form" : "div"} onSubmit={saveSlide}>
               <Input type="hidden" value={data.idSlideHome} name="idSlide" />
               <Col large={12} className="section">
                  <Grid className="row">
                     <ColHome>
                        <Label className="label align">Título:</Label>
                        <DynamicInput name={`title`} editable={editable} value={data.title} />
                     </ColHome>
                  </Grid>
                  <Grid className="row">
                     <ColHome>
                        <Label className="label align">Subtítulo:</Label>
                        <DynamicInput name={`subtitle`} editable={editable} value={data.subtitle} />
                     </ColHome>
                     {/* <Col large={1} /> */}
                     <ColHome>
                        <Label className="label">Link:</Label>
                        <DynamicInput type="url" name={`link`} editable={editable} value={data.url} />
                     </ColHome>
                  </Grid>
               </Col>
               {/* Imágenes */}
               <Col large={12} className="section">
                  <Label className="title">Imágenes:</Label>
                  <Grid>
                     <EditableImg
                        title="Desktop"
                        name={`imgDesk${data.idSlideHome}`}
                        fileName={data.pathImageWebDesktop}
                        label="Desktop medida aprox 1024px x 845px"
                        editable={editable}
                     />
                     <EditableImg
                        title="Subtítulo"
                        name={`imgMobile${data.idSlideHome}`}
                        fileName={data.pathImageWebMobile}
                        label="Mobile medidas aprox 510px x 700"
                        editable={editable}
                     />
                  </Grid>
               </Col>
               {editable && (
                  <Col large={4} offsetL={10}>
                     <AppButton>Guardar</AppButton>
                  </Col>
               )}
            </Grid>
         </ItemStyled>
         <AppLoader isVisible={isSaving} />
      </>
   );
}

const ColHome = styled.div`
   display: flex;
   margin-right: 1.5em;
   // margin-bottom: 2em;

   & .label {
      margin-right: 1em;
      width: auto;

      &.align {
         width: 70px;
         display: block;
      }
   }
`;
